import { plainToClass } from 'class-transformer';
import {
  API_ROLE_CREATE,
  API_ROLE_DELETE,
  API_ROLE_FIND_ALL,
  API_ROLE_FIND_ONE,
  API_ROLE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { RoleDto } from '../dto';
import { FindAllResponse } from '../types';

export class RoleApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<RoleDto>> {
    return this.httpClient
      .get(API_ROLE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(RoleDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<RoleDto> {
    return this.httpClient
      .get(API_ROLE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(RoleDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<RoleDto> {
    return this.httpClient.post(API_ROLE_CREATE, data).then(({ data }) => {
      return plainToClass(RoleDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<RoleDto> {
    return this.httpClient.put(API_ROLE_UPDATE, data).then(({ data }) => {
      return plainToClass(RoleDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_ROLE_DELETE, {
      pathParams: { uuid }
    });
  }
}
